"use client";
import React, { Fragment, useEffect } from "react";
import { useSearchParams } from "next/navigation";
import PageLayout from "@/layouts/pageLayout";
import { scrollToElement } from "@/utils/scrollToElement";
import PillarsComponent from "./components/pillars";
import HeroComp from "./components/hero";
import VisionComp from "./components/futureVision";
import SecurityAchievements from "./components/ourAchievements";

const AboutUsPage = () => {
  const searchParams = useSearchParams();
  const section = searchParams.get("section");
  useEffect(() => {
    if (section) {
      scrollToElement(section, 120);
    }
  }, [section]);
  return (
    <Fragment>
      <HeroComp />
      <PageLayout>
        <VisionComp />
        <PillarsComponent />
      </PageLayout>
      <SecurityAchievements />
      <PageLayout
        showCertificates
        showCustomers
        showFeatures
        showTechPartners
        showContactForm
      >
        {null}
      </PageLayout>
    </Fragment>
  );
};

export default AboutUsPage;
